<template lang="pug">
  el-dropdown(trigger='click')
    el-button(type='primary', size="small")
      | Ações
      i.el-icon-arrow-down.el-icon--right
    el-dropdown-menu(slot='dropdown')
      template(v-for="acao in acoes")
        el-dropdown-item(v-if="acao.active")
          .flex(@click="acao.click")
            i.material-icons {{acao.icon}}
            | &nbsp {{acao.title}}
</template>

<script>
export default {
  props: {
    acoes: {
      type: Array,
      required: true
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

  .label {
    padding-bottom: 5px;
    font-size: 14px;

    .required{
      color: $error;
    }
  }

  p {
    color:$font-dark-color !important;
    font-size:14px;
  }

  .flex {
    display: flex;
    align-items: center;
    justify-content: left;
  }

  .material-icons {
    width: 24px;
  }

</style>



// WEBPACK FOOTER //
// src/components/ButtonAcoes.vue